// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"234":"7b9fae7e5285e7ad","804":"32f7cb15d50b9308"}[chunkId] + ".js";
};